// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1E-Mt","legacyBtn":"MutateMid_legacyBtn__1gkA8"};